import { createContext } from "react";

const fleetSettingsContext = createContext();

export default fleetSettingsContext;
